/**
 * @description 分享事件
 * @author yanchaoren
 */

/**
 * 拉起分享
 */
export default function invokeShare () {
    const shareData = window.__DATA__.shareData
    console.log(window.__DATA__.shareData)
    K.setShare(shareData)
    K.invokeShare()
}
